import { BaseAdapter } from "@modules/+new/payments/shared-payments/entities/base-adapter";
import { FiatTransactionPaymentDto } from "@modules/+new/transactions/infrastructure/dto/fiat-transaction-payment.dto";

export interface FiatTransactionPayment {
	readonly paymentUrl: string;
}

export class FiatTransactionPaymentDtoAdapter extends BaseAdapter<FiatTransactionPaymentDto, FiatTransactionPayment> {
	public adapt(item: FiatTransactionPaymentDto): FiatTransactionPayment | null {
		if (!item) {
			return null;
		}

		return { paymentUrl: item.payment_url };
	}
}
